import type { RecoveryOutcome, RecoveryOwner } from '../streamRecovery/contracts';
import type { RecoveryActionArbiter } from '../streamRecovery/interfaces';

/** One in-flight rebuild per session. Completed IDs remain rejected until final teardown. */
export class SessionRecoveryActionArbiter implements RecoveryActionArbiter {
  private active?: { episodeId: string; owner: RecoveryOwner };
  private completed = new Set<string>();
  private saturated = false;
  private static readonly MAX_COMPLETED_EPISODES = 1024;

  tryBegin(episodeId: string, owner: RecoveryOwner): boolean {
    if (!episodeId || this.active || this.saturated || this.completed.has(episodeId)) return false;
    this.active = { episodeId, owner };
    return true;
  }

  finish(episodeId: string, _outcome: RecoveryOutcome): void {
    if (this.active?.episodeId !== episodeId) return;
    this.active = undefined;
    this.completed.add(episodeId);
    // Fail closed instead of evicting an ID whose delayed callback could still arrive.
    if (this.completed.size >= SessionRecoveryActionArbiter.MAX_COMPLETED_EPISODES) this.saturated = true;
  }

  reset(): void {
    this.active = undefined;
    this.completed.clear();
    this.saturated = false;
  }
}
